<div style="padding: 10px; min-width: 400px;">
  <div style="border: 1px solid #ccc; border-radius: 6px; padding: 4px; margin-bottom: 16px;">
    <dx-list data-testid="reject-tasks-list"
      [dataSource]="rollbackTasks"
      selectionMode="single"
      [(selectedItems)]="selectedRollbackTasks"
      height="300"
      class="dx-list"
    >
      <div *dxTemplate="let data of 'item'">
        <div style="display: flex; justify-content: left;">
          <span style="min-width: 80px; display: inline-block;">{{ data.taskId }}</span>
          <span style="padding-left: 16px;">{{ data.name }}</span>
        </div>
      </div>
    </dx-list>
  </div>
  <div style="margin: 20px 0;">
    <dx-select-box data-testid="reject-tasks-reason-select"
      [(value)]="rejectReason"
      [dataSource]="rejectReasonOptions"
      [disabled]="!selectedRollbackTasks || selectedRollbackTasks.length === 0"
      placeholder="Select rejection reason"
      [showClearButton]="true"
      [isValid]="!!rejectReason && rejectReason.trim().length > 0"
      [validationError]="{ message: 'Reject reason is required.' }"
      style="width: 100%; margin-bottom: 16px;">
    </dx-select-box>
    <dx-text-area data-testid="reject-tasks-text-area"
      id="reject-tasks-text-area"
      #textArea
      [(value)]="comment"
      [disabled]="!selectedRollbackTasks || selectedRollbackTasks.length === 0"
      placeholder="Enter rejection comment"
      (keyup)="onKeyUp($event)"
      height="80"
      style="width: 100%;"
      showClearButton="true"
      [isValid]="!!comment && comment.trim().length > 0"
      [validationError]="{ message: 'Comment is required.' }"
    ></dx-text-area>
  </div>
  <dx-popup data-testid="reject-tasks-mention-popup"
    #userPopup
    height="250"
    width="300"
    [position]="{ my: 'left top', at: 'left bottom', of: '#reject-tasks-text-area' }"
    [showCloseButton]="false"
    [showTitle]="false"
    [(visible)]="popupVisible"
    contentTemplate="popupContent"
    [shading]="false"
    [focusStateEnabled]="false"
    [dragEnabled]="false"
    [resizeEnabled]="false">

    <div *dxTemplate="let data of 'popupContent'">
      <dx-list data-testid="reject-tasks-mention-list"
        [dataSource]="filteredUsers"
        [height]="200"
        displayExpr="fullName"
        [searchEnabled]="false"
        (onItemClick)="onUserSelected($event)"
        [showSelectionControls]="false"
        [focusStateEnabled]="false">
        <div *dxTemplate="let user of 'item'">
          <div data-testid="reject-tasks-mention-user-item" class="user-item">
            <div class="user-name">{{ user.fullName }}</div>
            <div class="user-email">{{ user.email }}</div>
          </div>
        </div>
      </dx-list>
    </div>
  </dx-popup>
  <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
    <dx-button data-testid="reject-tasks-button" class="dx-button"
      text="Reject"
      type="normal"
      [disabled]="!selectedRollbackTasks || selectedRollbackTasks.length === 0 || !rejectReason || rejectReason.trim().length === 0 || !comment || comment.trim().length === 0"
      (onClick)="onSubmit()">
    </dx-button>
    <dx-button data-testid="reject-tasks-user-button" class="user-button" text="Dismiss" type="normal" (onClick)="onDismiss()"></dx-button>
  </div>
</div>

